import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownToLine } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { MenuItem } from '@chakra-ui/react';

export const BottomAlignButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().setVerticalAlign('bottom').run()}
         isDisabled={editor.isActive({ verticalAlign: 'bottom' })}
         icon={<FontAwesomeIcon icon={faArrowDownToLine} size="lg" />}
         title={_js('Bottom Align')}
         iconSpacing={0}
      ></MenuItem>
   );
};
